/**
 * Кебаб-меню (⋮) действий статьи — desktop-вход в те же действия, что и
 * long-tap sheet на touch (term-actions.js, правило 40-frontend/p_40-longpress.md). Показывается
 * только на раскрытом термине (.zaglavie.expanded, term-menu.css). Пункты —
 * реальные .edit-entry-btn/.tg-send-btn (не проксирующие копии): их клики
 * уже слушают глобально account.js и editor/events.js, здесь только
 * открытие/закрытие панели.
 *
 * Закрытие по клику на пункт меню и по клику снаружи сделано на mousedown,
 * а не на click: и account.js, и editor/events.js вешают на document
 * capture-фазный click-обработчик с stopPropagation — событие click гасится
 * ДО того, как дойдёт до любого другого click-слушателя ниже по дереву
 * (включая сам элемент и document-уровневые обработчики, добавленные позже
 * в порядке регистрации). mousedown идёт независимым путём и не блокируется.
 */
(function () {
  'use strict';

  function openMenuEl() {
    return document.querySelector('.zaglavie-more-menu.is-open');
  }

  function getTrigger(menu) {
    var wrapper = menu.closest('.zaglavie-actions');
    return wrapper ? wrapper.querySelector('.zaglavie-more-btn') : null;
  }

  function closeMenu(menu) {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    var trigger = getTrigger(menu);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (document.activeElement && menu.contains(document.activeElement)) {
      document.activeElement.blur();
    }
  }

  function closeAll() {
    closeMenu(openMenuEl());
  }

  function focusFirstItem(menu) {
    var items = menu.querySelectorAll('.edit-entry-btn, .tg-send-btn, .revision-history-btn');
    for (var i = 0; i < items.length; i++) {
      // offsetParent === null покрывает и display:none (нет прав/не tg-linked),
      // и visibility:hidden на самой панели (сюда мы уже не попадём) —
      // надёжный признак "реально показан".
      if (items[i].offsetParent !== null) {
        items[i].focus();
        return;
      }
    }
  }

  function openMenu(trigger) {
    closeAll();
    var wrapper = trigger.closest('.zaglavie-actions');
    var menu = wrapper && wrapper.querySelector('.zaglavie-more-menu');
    if (!menu) return;
    menu.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { focusFirstItem(menu); });
  }

  // ---- открытие/переключение по клику на триггер ----
  document.addEventListener('click', function (ev) {
    var trigger = ev.target.closest && ev.target.closest('.zaglavie-more-btn');
    if (!trigger) return;
    ev.stopPropagation();
    var wrapper = trigger.closest('.zaglavie-actions');
    var menu = wrapper && wrapper.querySelector('.zaglavie-more-menu');
    if (menu && menu.classList.contains('is-open')) {
      closeMenu(menu);
    } else {
      openMenu(trigger);
    }
  });

  // ---- закрытие по клику на пункт меню или снаружи (mousedown, см. шапку) ----
  document.addEventListener('mousedown', function (ev) {
    var menu = openMenuEl();
    if (!menu) return;
    var trigger = getTrigger(menu);
    if (trigger && trigger.contains(ev.target)) return; // сам триггер — toggle обработает click

    // Клик ПО ПУНКТУ меню (.edit-entry-btn/.tg-send-btn): нельзя прятать панель
    // прямо на mousedown — панель ушла бы в display:none, кнопка перестала бы
    // существовать в layout, и браузер НЕ сгенерировал бы click на ней →
    // обработчики действий (account.js для tg-send, editor/events.js для edit,
    // оба на click) не сработали бы вовсе. Откладываем закрытие на следующий
    // тик: setTimeout(0) выполнится уже ПОСЛЕ mouseup→click, когда действие
    // отработало. Авто-закрытие после действия сохраняется; для tg-send панель
    // всё равно остаётся видимой во время отправки через CSS :has(.sending)
    // (term-menu.css), даже когда is-open уже снят.
    var item = ev.target.closest && ev.target.closest('.edit-entry-btn, .tg-send-btn, .revision-history-btn');
    if (item && menu.contains(item)) {
      setTimeout(function () { closeMenu(menu); }, 0);
      return;
    }

    closeMenu(menu); // клик снаружи — закрываем сразу
  });

  // ---- клавиатура ----
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') {
      var menu = openMenuEl();
      if (!menu) return;
      var trigger = getTrigger(menu);
      closeMenu(menu);
      if (trigger) trigger.focus();
      return;
    }
    // Enter/Space на пункте меню: сама кнопка обработает активацию нативно
    // (см. шапку файла — keydown не блокируется чужими click-перехватчиками),
    // здесь только закрываем панель для клавиатурных пользователей.
    if (ev.key === 'Enter' || ev.key === ' ') {
      var item = ev.target.closest && ev.target.closest(
        '.zaglavie-more-menu.is-open .edit-entry-btn, .zaglavie-more-menu.is-open .tg-send-btn'
      );
      if (item) {
        var itemMenu = item.closest('.zaglavie-more-menu');
        if (itemMenu) closeMenu(itemMenu);
      }
    }
  });

  // Публичный хук для ui.js: раскрытие/сворачивание термина закрывает меню.
  window.SEARCH_TERM_MENU = { closeAll: closeAll };
})();
